import {AppState} from '@app/redux';
import {createSelector} from '@ngrx/store';
import {SimulationState} from '@app/welfy-plugin/welfy/calculator/redux/simulation.reducer';

export const selectFeature = (appState: AppState) => appState.simulation;

export const selectProjects = createSelector(
  selectFeature,
  (state: SimulationState) => state.projects
);
export const selectCurrentProject = createSelector(
  selectFeature,
  (state: SimulationState) => state.currentProject
);
